import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ApiRequestService } from "../../../services/api-request.service";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-minhas-aulas-add-video-youtube",
  templateUrl: "./minhas-aulas-add-video-youtube.component.html",
  styleUrls: ["./minhas-aulas-add-video-youtube.component.scss"],
})
export class MinhasAulasAddVideoYoutubeComponent {
  videos: any[] = [];
  selectedVideos: any[] = [];
  selectedVideo: any = undefined;
  page: number = 1;
  total: number = 0;
  carregando: boolean = false;
  adicionando: boolean = false;
  iFrame: string = "";
  requisicao: any;

  multiple: boolean = true;

  constructor(
    private api: ApiRequestService,
    public dialogRef: MatDialogRef<MinhasAulasAddVideoYoutubeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient
  ) {}

  AddVideos() {
    const videoId = this.GetVideoId(this.iFrame);

    this.api.Get(`content/youtube/${videoId}`).subscribe((response: any) => {

      const payload = 
      [
        {
          origin: 'youtube',
          uri: videoId,
          image: response.image,
          title: response.title,
          iframe: this.UpdateIFrameSize(this.iFrame),
          description: response.description,
          total_time: response.duration,
        }
      ];

      this.api
        .Post("content/" + this.data.aula.id + "/video", { videos: payload })
        .subscribe(
          (res: any) => {
            this.dialogRef.close({res, videoId});
          },
          (error) => {
            this.adicionando = false;
            console.log(error);
            alert("Erro ao adicionar os vídeos");
          }
        );
      });
  }

  GetVideoId(iFrame: string) {
    var videoId = iFrame.match(/embed\/([a-zA-Z0-9_-]+)/);

    if (videoId && videoId[1]) {
        return videoId[1];
    } else {
        return null;
    }
  }

  UpdateIFrameSize(iFrame: string) {
    let updatedIFrame = iFrame.replace(/width="(\d+)"/, 'width="100%"');
    updatedIFrame = updatedIFrame.replace(/height="(\d+)"/, 'height="600"');

    return updatedIFrame;
  }

  UpdateVideo() {
    this.adicionando = true;

    const video = {
      id: this.data.params.id_video,
      origin: 'vimeo',
      uri: this.selectedVideos[0].uri,
      image: this.selectedVideos[0].pictures.sizes[2].link,
      title: this.selectedVideos[0].name,
      iframe: this.selectedVideos[0].embed.html,
      description: this.selectedVideos[0].description,
      total_time: this.selectedVideos[0].duration,
    };

    this.api.Put(`video/${this.data.params.id_video}`, video).subscribe(
      (res: any) => {
        this.dialogRef.close(res);
      },
      (error: any) => {
        this.adicionando = false;
        console.log(error);
        alert("Erro ao atualizar o video.");
      }
    );
  }

  SaveOrUpdateVideos() {
    if (this.multiple) {
      this.AddVideos();
    } else {
      this.UpdateVideo();
    }
  }

  Close(): void {
    this.dialogRef.close();
  }
}
